import { Route, Switch } from 'react-router-dom'
import notFoundPage from './features/404'
import Hemtjanst from './features/Hemtjanst'
import Start from './features/Start'
import Anvandare from './features/anvandare'
import NewAnvandare from './features/anvandare/new'
import SingleAnvandare from './features/anvandare/single'
import Case from './features/arende'
import SingleCase from './features/arende/single'
import ArendeFordelning from './features/arendeFordelning'
import BenchmarkingMainView from './features/benchmarking'
import Beslutsstod from './features/beslutsstod'
import Brukare from './features/brukare'
import SingleBrukare from './features/brukare/single'
import Handlaggare from './features/handlaggare'
import SingleHandlaggare from './features/handlaggare/single'
import LoginRedirect from './features/loginRedirect/loginRedirect'
import LogoutRedirect from './features/logoutRedirect/logoutRedirect'
import Medarbetare from './features/medarbetare'
import SingleMedarbetare from './features/medarbetare/single'
import MinaArendenTable from './features/minaArenden'
import NyligenUtgångnaTable from './features/nyligenUtgångna'
import flagInfo from './features/singleDeviation/singleDeviation'
import UtanförTeamstrkturTable from './features/utanforTeamStruktur'
import Utforare from './features/utforare'
import SingleUtforare from './features/utforare/single'
import VolumeTable from './features/volymuppfoljning'
import BenchmarkingIntroduction from './features/benchmarking/BenchmarkingInformation'
import Tags from './features/tags'
import SingleTag from './features/tags/single'
import NewTag from './features/tags/new'
import Guests from './features/guests'
import NewGuest from './features/guests/NewGuest'
import SingleGuest from './features/guests/SingleGuest'
import MiscSettings from './features/miscSettings'
import Roles from './features/roles'
import NewRole from './features/roles/NewRole'
import SingleRole from './features/roles/SingleRole'
import IBICBeslutsstodEditView from './features/beslutsstod/IBIC/config/IBICBeslutsstodEditView'
import IBICBeslutsstod from './features/beslutsstod/IBIC/IBICBeslutsstod'
import BeslutsstodFunktionsstod from './features/beslutsstod/beslutsstod-funktionsstod/BeslutsstodFunktionsstod'
import ForebyggandeInsatserTable from './features/forebyggandeInsatser/forebyggandeInsatserTable'
import FlagAdmin from './features/flagAdmin'
import GuardedRoute from './components/routeGuard/GuardedRoute'
import Malindex from './features/malindex'

/**
 * Rutterna går genom GuardedRoute, som slår upp sökvägen i utils/routePermissions.ts
 * och nekar allt som inte står med (#50). Lägger du till en rutt här måste den också
 * läggas till i kartan — annars blir den onåbar, vilket är det säkra felet.
 */
const navigation = () => {
  return (
    <Switch>
      <GuardedRoute exact path="/app/medarbetare" component={Medarbetare} />
      <GuardedRoute exact path="/app/medarbetare/:id" component={SingleMedarbetare} />
      <GuardedRoute exact path="/app/brukare" component={Brukare} />
      <GuardedRoute exact path="/app/brukare/id=:id&namn=:namn" component={SingleBrukare} />
      <GuardedRoute exact path="/app/handlaggare" component={Handlaggare} />
      <GuardedRoute exact path="/app/handlaggare/:id" component={SingleHandlaggare} />
      <GuardedRoute exact path="/app/utforare" component={Utforare} />
      <GuardedRoute exact path="/app/utforare/utforare=:utforare&from=:from&to=:to&flaglevel=:flaglevel&deviation=:deviation" component={SingleUtforare} />
      <GuardedRoute exact path="/app/forebyggande-insatser" component={ForebyggandeInsatserTable} />
      <GuardedRoute exact path="/app/arenden" component={Case} />
      <GuardedRoute exact path="/app/arenden/:id" component={SingleCase} />
      <GuardedRoute exact path="/app/avvikelse/flag=:flag&id=:id" component={flagInfo} />
      <GuardedRoute exact path="/app/anvandare" component={Anvandare} />
      <GuardedRoute exact path="/app/anvandare/ny" component={NewAnvandare} />
      <GuardedRoute exact path="/app/anvandare/:id" component={SingleAnvandare} />
      <GuardedRoute exact path="/app/taggar" component={Tags} />
      <GuardedRoute exact path="/app/taggar/ny" component={NewTag} />
      <GuardedRoute exact path="/app/taggar/:id" component={SingleTag} />
      <GuardedRoute exact path="/app/gäster" component={Guests} />
      <GuardedRoute exact path="/app/gäster/ny" component={NewGuest} />
      <GuardedRoute exact path="/app/gäster/:username" component={SingleGuest} />
      <GuardedRoute exact path="/app/roller" component={Roles} />
      <GuardedRoute exact path="/app/roller/ny" component={NewRole} />
      <GuardedRoute exact path="/app/roller/:name" component={SingleRole} />
      <GuardedRoute exact path="/app/övrigt" component={MiscSettings} />
      <GuardedRoute exact path="/app/beslutsstod" component={Beslutsstod} />
      <GuardedRoute exact path="/app/ibic-beslutsstod" component={IBICBeslutsstod} />
      <GuardedRoute exact path="/app/ibic-beslutsstod/config" component={IBICBeslutsstodEditView} />
      <GuardedRoute exact path="/app/beslutsstod-lss" component={BeslutsstodFunktionsstod} />
      <GuardedRoute exact path="/app/beslutsstod/:id" component={Beslutsstod} />
      <GuardedRoute exact path="/app/malindex" component={Malindex} />
      <GuardedRoute exact path="/app/malindex/:id" component={Malindex} />
      <GuardedRoute exact path="/app/arendefordelning" component={ArendeFordelning} />
      <GuardedRoute exact path="/app/hemtjanst" component={Hemtjanst} />
      <GuardedRoute exact path="/app/benchmarking/introduction" component={BenchmarkingIntroduction} />
      <GuardedRoute path="/app/benchmarking" component={BenchmarkingMainView} />
      <GuardedRoute exact path="/app/callback" component={LoginRedirect} />
      <GuardedRoute exact path="/app/logout_redirect" component={LogoutRedirect} />
      <GuardedRoute exact path="/app/start" component={Start} />
      <GuardedRoute exact path="/app/mina-arenden" component={MinaArendenTable} />
      <GuardedRoute exact path="/app/nyligen-utganga" component={NyligenUtgångnaTable} />
      <GuardedRoute exact path="/app/utanfor-teamstruktur" component={UtanförTeamstrkturTable} />
      <GuardedRoute exact path="/app/volymuppfoljning" component={VolumeTable} />
      <GuardedRoute exact path="/app/flaggkorning" component={FlagAdmin} />
      <Route path="*" component={notFoundPage} />
    </Switch>
  )
}

export default navigation
